/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlumeOulines } from './PlumeOulines';
import {
    PlumeOulinesFromJSON,
    PlumeOulinesFromJSONTyped,
    PlumeOulinesToJSON,
    PlumeOulinesToJSONTyped,
} from './PlumeOulines';

/**
 * 
 * @export
 * @interface PaginatedPlumeOulinesList
 */
export interface PaginatedPlumeOulinesList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedPlumeOulinesList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPlumeOulinesList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<PlumeOulines>}
     * @memberof PaginatedPlumeOulinesList
     */
    results: Array<PlumeOulines>;
}

/**
 * Check if a given object implements the PaginatedPlumeOulinesList interface.
 */
export function instanceOfPaginatedPlumeOulinesList(value: object): value is PaginatedPlumeOulinesList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedPlumeOulinesListFromJSON(json: any): PaginatedPlumeOulinesList {
    return PaginatedPlumeOulinesListFromJSONTyped(json, false);
}

export function PaginatedPlumeOulinesListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedPlumeOulinesList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(PlumeOulinesFromJSON)),
    };
}

export function PaginatedPlumeOulinesListToJSON(json: any): PaginatedPlumeOulinesList {
    return PaginatedPlumeOulinesListToJSONTyped(json, false);
}

export function PaginatedPlumeOulinesListToJSONTyped(value?: PaginatedPlumeOulinesList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(PlumeOulinesToJSON)),
    };
}

